/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
/* eslint no-undef: "off"*/
// eslint-disable-next-line

import React from 'react';
import { createRoot } from 'react-dom/client';
import AppRouter from './utils/AppRouter';
import history from './utils/history';
import { Provider } from 'react-redux';
import './scss/style.scss';
// import './assets/style/app.scss';
import App from './containers/App';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorker from './serviceWorker';
import { initializeFirebase } from './push-notification';
import configureStore from './store';
import intercepter from './utils/interceptor'
import config from './utils/config';
import { initAnalytics, reportBootstrapPageview } from './utils/analytics';
import { onAnalyticsConsent, configureMetaPixel, translateCookieBanner } from './utils/cookieConsent';
import { wipeLegacyCredentials } from './utils/legacyCredentials';
import { storedPixelId } from './utils/metaPixel';

const initGoogleAnalytics = ()=>{
  initAnalytics(config.gaTrackingId);
  reportBootstrapPageview(window.location.pathname + window.location.search);
}

// Before anything mounts: drop the plain-text password an old "remember me" left (PANEL-1611).
wipeLegacyCredentials();

const store = configureStore();
intercepter.setupInterceptors(store);
// React's concurrent root (PANEL-1541): automatic batching, which react-redux 9 relies on.
createRoot(document.getElementById('root')).render((
  <Provider store={store}>
    <AppRouter history={history}>
      {/* Inside the router on purpose: the fallback is part of the routed app, and a boundary
          wrapped around the router would take the router down with it (A-3). */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AppRouter>
  </Provider>
));

// Google Analytics starts only with analytics consent from the cookie banner (PANEL-1554): now, from a
// stored choice, or later when the member grants it.
if (config.isGaEnabled()) {
  onAnalyticsConsent(initGoogleAnalytics);
}

// The Meta Pixel loads through the same banner, in its marketing category: the id on the banner is all the
// consent script needs (PANEL-1632). A portal-wide id wins; else the one the Header remembered for the panel.
configureMetaPixel(config.metaPixelId || storedPixelId());

// The cookie banner (index.html, outside React) follows the portal language.
let bannerTranslator;
const syncCookieBannerLanguage = () => {
  const state = store.getState();
  const translator = state && state.auth && state.auth.language;
  if (translator === bannerTranslator) return;
  bannerTranslator = translator;
  translateCookieBanner(translator);
};
syncCookieBannerLanguage();
store.subscribe(syncCookieBannerLanguage);

// initialize firebase for push notification.
if (config.isFcmEnabled()) {
  initializeFirebase(config.fcmSenderId);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

// Register service worker for push notification.
if (config.isFcmEnabled() && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js', {scope: 'firebase-messaging-sw'}).then(function(registration) {
    console.log('[firebase-messaging-sw] Registered, scope :', registration.scope);
  }).catch(function(err) {
    console.log('[firebase-messaging-sw] failed, error:', err);
  });
}